<template>
  <v-container v-if="isReady">
    <v-fab-transition>
      <v-btn
        :x-large="$vuetify.breakpoint.smAndUp"
        color="primary"
        fixed
        bottom
        right
        fab
        @click="showIntercom()"
      >
        <v-icon
          :large="$vuetify.breakpoint.smAndUp"
          v-text="'mdi-facebook-messenger'"
        />
      </v-btn>
    </v-fab-transition>
  </v-container>
</template>
<script>
export default {
  name: "IntercomCustomers",
  props: {
    datas: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isReady: false,
  }),
  watch: {
    "$store.getters.storeInfo": function () {
      if (this.$store.getters.storeInfo) {
        if (this.$store.getters.guestInfo) {
          this.$intercom.boot({
            name:
              this.$store.getters.guestInfo.firstName +
              " " +
              this.$store.getters.guestInfo.lastName,
            phone: this.$store.getters.guestInfo.phoneNumber,
            email: this.$store.getters.guestInfo.email,
            orderRef: "",
            store: this.$store.getters.storeInfo.storeName,
            hide_default_launcher: true,
          });
        } else {
          this.$intercom.boot({
            store: this.$store.getters.storeInfo.storeName,
            hide_default_launcher: true,
          });
        }

        this.isReady = !!this.$store.getters.appInfo?.hasChatSupport;
      } else {
        this.isReady = false;
      }
    },
  },
  mounted() {
    const self = this;
    if (self.datas) {
      self.$intercom.boot({
        name: self.datas.customerFirstName + " " + self.datas.customerLastName,
        phone: self.datas.customerPhone,
        email: self.datas.customerEmail,
        orderRef: self.datas.publicRef,
        store: self.datas.Store.storeName,
        hide_default_launcher: true,
      });
    } else {
      if (self.$store.getters.user) {
        self.$intercom.boot({
          name:
            self.$store.getters.user.firstName +
            " " +
            self.$store.getters.userlastName,
          phone: self.$store.getters.user.phone,
          email: self.$store.getters.user.email,
          hide_default_launcher: true,
        });
        self.isReady = !!this.$store.getters.appInfo?.hasChatSupport;
      }
    }
  },
  methods: {
    showIntercom: function () {
      const self = this;
      self.$intercom.show();
    },
  },
};
</script>
